import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";

export const StyledPaper = styled(Paper)(() => ({
  borderRadius: 0,
  border: "1px solid rgba(216, 220, 229, 1)",
  boxShadow: "0px 4px 25px 0px rgba(49, 49, 49, 0.08)",
}));
